import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../theme/palette';

const style = () =>
  createStyles<'root', { backgroundColor: string }>({
    root: {
      borderRadius: palette.borderRadius.default,
      padding: '5px 10px 5px 10px',
      fontSize: '14px',
      backgroundColor: ({ backgroundColor }) => backgroundColor,
      '& span': {
        color: ({ backgroundColor }) =>
          backgroundColor ? palette.text.white : palette.text.primary
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
